import type { TypedGroupviewPanelState } from '../../../types/LayoutConfig';

const LEGACY_PANEL_TYPE: string = 'aggregatedMarketCap';
const NEW_PANEL_TYPE = 'aggregatedAssetMetric';
const DEFAULT_METRIC = 'CapMrktEstUSD';

/**
 * Rewrites legacy `aggregatedMarketCap` panel registrations to the new generic
 * `aggregatedAssetMetric` type. The legacy panel hardcoded the metric to
 * `CapMrktEstUSD`; we preserve that behavior for existing layouts by injecting
 * it into the persisted params when missing.
 *
 * - Both `dockview.contentComponent` (used by dockview to find the renderer)
 *   and `params.type` (used by panel renderers via discriminated-union typing)
 *   are rewritten in lockstep.
 * - Idempotent: re-running on already-migrated configs is a no-op.
 * - Only scoped to `spacesConfigs.trading.layouts` — the legacy panel was a
 *   Signals panel registered exclusively in the trading section.
 */
export function migrateAggregatedMarketCapToAssetMetric(config: Record<string, any>): void {
  const layouts = config?.spacesConfigs?.trading?.layouts;
  if (!Array.isArray(layouts)) {
    return;
  }
  for (const spec of layouts) {
    const panels = spec?.dockViewLayout?.panels;
    if (panels == null || typeof panels !== 'object') {
      continue;
    }
    for (const panel of Object.values(panels) as TypedGroupviewPanelState[]) {
      const hasLegacyContent = panel?.contentComponent === LEGACY_PANEL_TYPE;
      const hasLegacyParamType = panel?.params?.type === LEGACY_PANEL_TYPE;
      if (!hasLegacyContent && !hasLegacyParamType) {
        continue;
      }
      panel.contentComponent = NEW_PANEL_TYPE;
      panel.params =
        panel.params != null && typeof panel.params === 'object' && !Array.isArray(panel.params) ? panel.params : {};
      panel.params.type = NEW_PANEL_TYPE;
      if (panel.params.metric == null) {
        panel.params.metric = DEFAULT_METRIC;
      }
    }
  }
}
